import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ProductSlider from './Helpers/ProductSlider';
import { getCollectionList } from '../../../actions/kafairAction';
import { getCloudImageUrl } from '../../../utils';
import Countdown from 'react-countdown';
import moment from 'moment';
import styled from 'styled-components';

const CountDownWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const TimerContainer = styled.div`
  border-radius: 27px;
  padding: 12px 20px;
  background-color: #f7f7f7;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  p {
    margin-bottom: 0;
    font-size: 14px;
    font-family: Nunito-Regular;
    span {
      font-family: Nunito-Bold;
    }
  }
`;

const CountDownRenderer = ({
  formatted: { days, hours, minutes, seconds },
  completed,
  ...props
}) => {
  if (completed)
    return (
      <p>
        ends in <span>00</span> : <span>00</span> : <span>00</span> :{' '}
        <span>00</span>
      </p>
    );
  return (
    <p>
      ends in <span>{days}</span> : <span>{hours}</span> :{' '}
      <span>{minutes}</span> : <span>{seconds}</span>
    </p>
  );
};

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

interface URL {
  URL: string;
}

type CollectionHero = {
  title: string;
  images: URL;
  slug: string;
  category: string;
  history: History;
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => any;
  isPreVerified: boolean;
};

const CollectionHero: FC<CollectionHero> = ({
  title,
  images,
  slug,
  category,
  history,
  getCollectionList,
  isPreVerified,
}) => {
  const [dataProducts, setDataProducts] = useState([]);
  const [categoryUrl, setCategoryUrl] = useState('');
  const [started_at, setStartedAt] = useState(null);
  const [expiry, setExpiry] = useState(null);
  const [collectionId, setCollectionId] = useState(null);

  useEffect(() => {
    if (slug && !isPreVerified) {
      let payload = {
        availables: true,
        per_page: 11,
        page: 1,
      };

      let name = slug.replace('-', '_');

      getCollectionList(category, slug, payload, name).then(({ value }) => {
        setCollectionId(value?.data?.id ?? null);
        setExpiry(value.data.expiry);
        setStartedAt(value.data.starts_at);
        setDataProducts(value.data.products.data);
      });
    }
    if (slug && isPreVerified) {
      let payload = {
        availables: true,
        per_page: 11,
        page: 1,
        pre_verified: true,
        sort_by: 'price_asc',
      };

      let name = slug.replace('-', '_');

      getCollectionList(category, slug, payload, name).then(({ value }) => {
        setCollectionId(value?.data?.id ?? null);
        setExpiry(value.data.expiry);
        setStartedAt(value.data.starts_at);
        setDataProducts(value.data.products.data);
      });
    }
  }, [slug, isPreVerified]);

  useEffect(() => {
    const categoryParams =
      category === 'lifestyles'
        ? 'electronics-collectibles'
        : category === 'apparels' || category === 'Apparels'
        ? 'apparel'
        : category === 'handbags'
        ? 'luxury'
        : category;

    setCategoryUrl(categoryParams);
  }, [category]);

  if (dataProducts && dataProducts.length === 0) return null;

  return (
    <div className="collectionList-page">
      {images && (
        <div
          className="collectionList-header"
          onClick={() => {
            let pathname = `/${categoryUrl}/collection/${slug}`;
            if (isPreVerified) pathname += '?pre_verified=true';
            history.push(pathname);
            localStorage.removeItem('collectionSortedBy');
          }}
        >
          <KickImage noCompress src={images.URL} alt="header.." />
        </div>
      )}
      {started_at && expiry ? (
        <CountDownWrapper>
          <TimerContainer>
            <Countdown date={moment(expiry)} renderer={CountDownRenderer} />
          </TimerContainer>
        </CountDownWrapper>
      ) : null}
      {dataProducts && dataProducts.length > 0 && (
        <div
          style={{
            padding:
              window.screen.availWidth < 480 ? '0px' : '0px 40px 0px 40px',
            width: window.screen.availWidth > 480 && '95%',
            marginLeft: window.screen.availWidth < 480 ? null : '2.5%',
          }}
        >
          <ProductSlider
            dataProducts={dataProducts}
            title={title}
            activeBrowseAll
            chosenOption={title}
            navigateUrl={
              isPreVerified
                ? `/${categoryUrl}/collection/${slug}?pre_verified=true`
                : `/${categoryUrl}/collection/${slug}`
            }
            history={history}
            isCollectionHero={isPreVerified}
            isPreVerified={isPreVerified}
            slug={slug}
            collectionId={collectionId}
          />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (
    category: string,
    slug: string,
    payload: Object,
    name: string,
  ) => dispatch(getCollectionList(category, slug, payload, name)),
});

export default connect(null, mapDispatchToProps)(withRouter(CollectionHero));
